// test944
(944 && 0);
